/*
 * Backpack - Skyscanner's Design System
 *
 * Copyright 2016 Skyscanner Ltd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Values must stay in sync with bpk-mixins/_surfaces.scss
export const SURFACE_COLORS = {
  surfaceDefault: 'surface-default',
  surfaceElevated: 'surface-elevated',
  surfaceHero: 'surface-hero',
  surfaceContrast: 'surface-contrast',
  surfaceHighlight: 'surface-highlight',
  surfaceSubtle: 'surface-subtle',
  surfaceLowContrast: 'surface-low-contrast',
  surfaceTint: 'surface-tint'
};